export default "__VITE_ASSET__DGbuAg4g__"